<p-accordion-header [class.bd-ai-accordion-header-with-history]="historyOpen()">
  @if (historyTitle().length > 0) {
    <div
      class="bd-ai-accordion-history-heading"
      data-id="assistant-chat-history-heading"
      tabindex="0"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <i class="ui-recent" aria-hidden="true"></i>
      <span class="bd-label-regular">{{ historyTitle() }}</span>
    </div>
  }
  <div class="flex w-full items-center justify-between">
    <div class="flex items-center gap-2">
      <ng-content select="[header-leading]" />
      <i [class]="icon()"></i>
      <span class="bd-label-regular">{{ title() }}</span>
      @if (answered()) {
        <bd-badge label="" type="neutral" customIcon="ui-check" />
      }
    </div>
    <div class="flex items-center gap-1 mr-1">
      <ng-content />
    </div>
  </div>
  <ng-template #toggleicon let-active="active">
    <p-button
      [text]="true"
      styleClass="bd-neutral bd-size-small"
      [icon]="active ? 'ui-up' : 'ui-down'"
      [tabindex]="-1"
      [attr.aria-hidden]="true"
    ></p-button>
  </ng-template>
</p-accordion-header>
